export const en = {
    addMoney: 'Top up',
    archived: 'Archived',
    'campaign-type-content_promotion': 'Content promotion',
    'campaign-type-cpm_banner': 'Display campaign',
    'campaign-type-cpm_deals': 'Private deals',
    'campaign-type-cpm_price': 'todo',
    'campaign-type-cpm_yndx_frontpage': 'Display campaign on Home page',
    'campaign-type-dynamic': 'Dynamic ads',
    'campaign-type-internal_autobudget': 'Auto-budget campaign',
    'campaign-type-internal_distrib': 'Distribution campaign',
    'campaign-type-internal_free': 'Free campaign',
    'campaign-type-mcbanner': 'Search banner',
    'campaign-type-mobile_content': 'Ads for mobile apps',
    'campaign-type-performance': 'Smart banners',
    'campaign-type-text': 'Text & Image Ads',
    changeCampaignDayBudget: 'Change daily ad campaign limit',
    changeWalletDayBudget: 'Change shared account limit',
    'description-content_promotion':
        'Promote content on the chosen platform by attracting your target audience for the search queries of your choice.',
    'description-cpm_banner':
        'Brand awareness advertising with payment per impression. Builds the brand image using interactive and engaging ad formats: banners, videos, and digital outdoor ads.',
    'description-cpm_deals':
        'Brand awareness campaign serving ads on certain sites. You are able to choose not only the audience but also specific sites to display ads on.',
    'description-cpm_yndx_frontpage':
        'For maximum reach and raising brand awareness. Premium banner on the Yandex Home page, with millions of daily visitors. CPM payment.',
    'description-dynamic':
        'Automatically-generated text ads for each of your products and their corresponding search query.',
    'description-internal_autobudget': 'Auto-budget campaign: description',
    'description-internal_distrib': 'Distribution campaign - description',
    'description-internal_free': 'Free campaign - description',
    'description-mcbanner':
        'Prominent branded banner placed to the right of search results. Uses the keywords you selected to attract your target audience.',
    'description-mobile_content':
        'Ad format that you can use to promote your iOS and Android apps. Allows you to get the maximum number of installations at the optimal price.',
    'description-performance':
        'Dynamic product banners. The system automatically selects an ad offer for each particular user.',
    'description-text':
        'Universal ads suitable for advertising the majority of products and services. Settings allow you to adjust a campaign to your target audience.',
    draft: 'Draft',
    'hint-content_promotion': 'Impressions on Yandex.Video',
    'hint-cpm_banner': 'Served in YAN with payment per impression',
    'hint-cpm_deals': 'Impressions on selected resources',
    'hint-cpm_yndx_frontpage': 'Impressions on the Yandex Home page',
    'hint-dynamic': 'Impressions on search',
    'hint-internal_autobudget': 'Auto-budget campaign',
    'hint-internal_distrib': 'Distribution campaign',
    'hint-internal_free': 'Free campaign',
    'hint-mcbanner': 'Impressions on search',
    'hint-mobile_content': 'Only on mobile devices',
    'hint-performance': 'Impressions in ad networks',
    'hint-text': 'Impressions on search and in ad networks',
    isInProgress: 'Processing',
    isNotRecovered: 'Not subject to recovery',
    isOverOnDate: 'Ended {date}',
    moderationDenied: 'Rejected by moderation',
    moderationPending: 'Under moderation',
    moneyFinished: 'Insufficient funds',
    noActiveBanners: 'No active banners',
    sendToModeration: 'Submit for moderation',
    showsWillStartAtTime: 'Impressions will begin at {time}',
    showsWillStartOnDateAtTime: 'Impressions will begin on {date} at {time}',
    showsWillStartOnFridayAtTime: 'Serving will begin on Friday at {time}',
    showsWillStartOnMondayAtTime: 'Serving will begin on Monday at {time}',
    showsWillStartOnSaturdayAtTime: 'Serving will begin on Saturday at {time}',
    showsWillStartOnSundayAtTime: 'Serving will begin on Sunday at {time}',
    showsWillStartOnThursdayAtTime: 'Serving will begin on Thursday at {time}',
    showsWillStartOnTuesdayAtTime: 'Serving will begin on Tuesday at {time}',
    showsWillStartOnWednesdayAtTime: 'Impressions will start on Wednesday at {time}',
    showsWillStartTomorrowAtTime: 'Impressions will begin tomorrow at {time}',
    started: 'Started',
    stopped: 'Stopped',
    temporarilyPaused: 'Temporarily paused',
    waitPayment: 'Awaiting payment',
    willStartOnDate: 'Starts on {date}'
};
